import React from 'react';
import { CheckIcon, ZapOffIcon, CodeIcon, InfinityIcon } from 'lucide-react';
import { Reveal } from './Reveal';
const reasons = [{
  icon: ZapOffIcon,
  title: 'Zero Friction',
  text: 'No necesitas saber de prompts complejos.'
}, {
  icon: CodeIcon,
  title: 'Zero Code',
  text: 'Todo sucede dentro de ChatGPT.'
}, {
  icon: InfinityIcon,
  title: 'Infinite Scale',
  text: 'Crea 1 o 100 lanzamientos al mes.'
}];
export function ReasonWhySection() {
  return <section className="w-full bg-black py-12 sm:py-24" data-id="element-131">
      <div className="mx-auto max-w-5xl px-4" data-id="element-132">
        <Reveal data-id="element-133">
          <h2 className="text-center font-display text-2xl text-white sm:text-4xl" data-id="element-134">
            ¿Por qué <span className="text-orange-500" data-id="element-135">Launch Machine</span> es
            diferente?
          </h2>
        </Reveal>

        <div className="mt-8 grid gap-4 sm:mt-12 sm:grid-cols-3" data-id="element-136">
          {reasons.map(({
          icon: Icon,
          title,
          text
        }, i) => <Reveal key={title} delay={i * 0.08} data-id="element-137">
              <div className="h-full rounded-2xl border border-zinc-800 bg-zinc-900/60 p-7 text-center" data-id="element-138">
                <span className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-orange-500/10 text-orange-500" data-id="element-139">
                  <Icon className="h-6 w-6" aria-hidden="true" data-id="element-140" />
                </span>
                <h3 className="mt-5 flex items-center justify-center gap-1.5 font-display text-lg text-white" data-id="element-141">
                  <CheckIcon className="h-5 w-5 text-green-400" aria-hidden="true" data-id="element-142" />
                  {title}
                </h3>
                <p className="mt-2 text-sm text-zinc-400" data-id="element-143">{text}</p>
              </div>
            </Reveal>)}
        </div>
      </div>
    </section>;
}